module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"homepage":"Homepage"}}')
  delete Component.options._Ctor
}
